import ButtonComponent from "../ButtonComponent/buttonComponent";
import styles from "./courseCardComponent.module.scss";
export const CourseCardComponent = (props) => {
    const {
        title,
        subText = "",
        timePeriod,
        onPrimaryClick,
        primaryButtonType = "inverse",
        primaryButtonText,
        showHighlighter,
        doNotShowCourseLength
    } = props;

    const getCourseString = () => {
        const { min, max, unit } = timePeriod || {};
        let courseString = "";
        if (min) {
            courseString += min;
        }
        if (max) {
            courseString += ` - ${max} `;
        }
        if (unit) {
            courseString += unit;
        }
        return courseString;
    };
    return (
        <div className={styles.courseCard}>
            <div className={styles.title}>{title}</div>
            {subText && <div className={styles.subText}>{subText}</div>}
            <div>
                {!doNotShowCourseLength ? <div className={styles.timePeriod}>
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M4.16667 18.3332C3.70833 18.3332 3.31597 18.17 2.98958 17.8436C2.66319 17.5172 2.5 17.1248 2.5 16.6665V4.99984C2.5 4.5415 2.66319 4.14914 2.98958 3.82275C3.31597 3.49637 3.70833 3.33317 4.16667 3.33317H5V1.6665H6.66667V3.33317H13.3333V1.6665H15V3.33317H15.8333C16.2917 3.33317 16.684 3.49637 17.0104 3.82275C17.3368 4.14914 17.5 4.5415 17.5 4.99984V16.6665C17.5 17.1248 17.3368 17.5172 17.0104 17.8436C16.684 18.17 16.2917 18.3332 15.8333 18.3332H4.16667ZM4.16667 16.6665H15.8333V8.33317H4.16667V16.6665ZM4.16667 6.6665H15.8333V4.99984H4.16667V6.6665ZM10 11.6665C9.76389 11.6665 9.56597 11.5866 9.40625 11.4269C9.24653 11.2672 9.16667 11.0693 9.16667 10.8332C9.16667 10.5971 9.24653 10.3991 9.40625 10.2394C9.56597 10.0797 9.76389 9.99984 10 9.99984C10.2361 9.99984 10.434 10.0797 10.5938 10.2394C10.7535 10.3991 10.8333 10.5971 10.8333 10.8332C10.8333 11.0693 10.7535 11.2672 10.5938 11.4269C10.434 11.5866 10.2361 11.6665 10 11.6665ZM6.66667 11.6665C6.43056 11.6665 6.23264 11.5866 6.07292 11.4269C5.91319 11.2672 5.83333 11.0693 5.83333 10.8332C5.83333 10.5971 5.91319 10.3991 6.07292 10.2394C6.23264 10.0797 6.43056 9.99984 6.66667 9.99984C6.90278 9.99984 7.10069 10.0797 7.26042 10.2394C7.42014 10.3991 7.5 10.5971 7.5 10.8332C7.5 11.0693 7.42014 11.2672 7.26042 11.4269C7.10069 11.5866 6.90278 11.6665 6.66667 11.6665ZM13.3333 11.6665C13.0972 11.6665 12.8993 11.5866 12.7396 11.4269C12.5799 11.2672 12.5 11.0693 12.5 10.8332C12.5 10.5971 12.5799 10.3991 12.7396 10.2394C12.8993 10.0797 13.0972 9.99984 13.3333 9.99984C13.5694 9.99984 13.7674 10.0797 13.9271 10.2394C14.0868 10.3991 14.1667 10.5971 14.1667 10.8332C14.1667 11.0693 14.0868 11.2672 13.9271 11.4269C13.7674 11.5866 13.5694 11.6665 13.3333 11.6665ZM10 14.9998C9.76389 14.9998 9.56597 14.92 9.40625 14.7603C9.24653 14.6005 9.16667 14.4026 9.16667 14.1665C9.16667 13.9304 9.24653 13.7325 9.40625 13.5728C9.56597 13.413 9.76389 13.3332 10 13.3332C10.2361 13.3332 10.434 13.413 10.5938 13.5728C10.7535 13.7325 10.8333 13.9304 10.8333 14.1665C10.8333 14.4026 10.7535 14.6005 10.5938 14.7603C10.434 14.92 10.2361 14.9998 10 14.9998ZM6.66667 14.9998C6.43056 14.9998 6.23264 14.92 6.07292 14.7603C5.91319 14.6005 5.83333 14.4026 5.83333 14.1665C5.83333 13.9304 5.91319 13.7325 6.07292 13.5728C6.23264 13.413 6.43056 13.3332 6.66667 13.3332C6.90278 13.3332 7.10069 13.413 7.26042 13.5728C7.42014 13.7325 7.5 13.9304 7.5 14.1665C7.5 14.4026 7.42014 14.6005 7.26042 14.7603C7.10069 14.92 6.90278 14.9998 6.66667 14.9998ZM13.3333 14.9998C13.0972 14.9998 12.8993 14.92 12.7396 14.7603C12.5799 14.6005 12.5 14.4026 12.5 14.1665C12.5 13.9304 12.5799 13.7325 12.7396 13.5728C12.8993 13.413 13.0972 13.3332 13.3333 13.3332C13.5694 13.3332 13.7674 13.413 13.9271 13.5728C14.0868 13.7325 14.1667 13.9304 14.1667 14.1665C14.1667 14.4026 14.0868 14.6005 13.9271 14.7603C13.7674 14.92 13.5694 14.9998 13.3333 14.9998Z"
                            fill="#DB3D35"
                        />
                    </svg>

                    {getCourseString()}
                </div>: null}
                <div>
                    <ButtonComponent onClick={onPrimaryClick} type={primaryButtonType}>
                        {primaryButtonText}
                    </ButtonComponent>
                </div>
            </div>

            {showHighlighter && <div className={styles.cardHighlighter} />}
        </div>
    );
};
